import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../Constant/api";
import DataTable from "react-data-table-component";

const columns = [
  // {
  //   id: 1,
  //   name: "id",
  //   selector: (row) => row.id,
  //   sortable: true,
  //   reorder: true,
  //   width: "100px"
  // },
  {
    id: 2,
    name: "Name",
    selector: (row) => row.meta.name,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "Roll",
    selector: (row) => row.meta.roll_no,
    sortable: true,
    reorder: true
  },
  {
    id: 4,
    name: "Phone",
    selector: (row) => row.meta.phone,
    sortable: true,
    reorder: true
  },
  {
    id: 5,
    name: "Course",
    selector: (row) => Object.values(JSON.parse(row.meta.course_details)).map((item, index) => (item.course_name)),
    sortable: true,
    reorder: true
  },
  {
    id: 7,
    name: "Status",
    selector: (row) => row.meta.is_active,
    sortable: true,
    reorder: true
  },
  {
    id: 6,
    name: "View",
    cell: (row) => <Link to={`${slugs.students_details}${row.slug}`}>View</Link>,

  }
];

export default function AllStudent() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")
  const [ImportData, setImportData] = React.useState([])
  const [toStudentModel, setToStudentModal] = React.useState(false)
  const [batchList, setBatchList] = React.useState([])
  const [batchSelectListModal, setBatchSelectListModal] = React.useState(false)
  const [batchSelectList, setBatchSelectList] = React.useState([])
  const [batchCacheList, setBatchCacheList] = React.useState([])
  const [CourseSelectModal, setCourseSelectModal] = React.useState(false)
  const [CourseSelectIndex, setCourseSelectIndex] = React.useState(0)
  const [CourseSelectItem, setCourseSelectItem] = React.useState(false)
  const [PaidAmount, setPaidAmount] = React.useState("")
  const [CourseAmount, setCourseAmount] = React.useState("")

  const [CourseDetails, setCourseDetails] = React.useState([])

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta"
      }, slugs.db_slug_students)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }

  useEffect(() => {
    GetAllProjects()
    getBatches()
  }, [])

  const getBatches = () => {
    AdsGETApiAuth({
      _fields: "id,meta,title",
      per_page: 100
    }, slugs.db_slug_batches)
      .then((res) => {
        setBatchList(res.data)
      })
  }

  const [file, setFile] = React.useState();
  const fileReader = new FileReader();
  const fileRefSingle = React.createRef();
  const date = new Date();
  const handleOnChange = (e) => {
    // setFile(e.target.files[0]);
    e.preventDefault();
    const file = e.target.files[0]
    if (file) {
      fileReader.onload = function (event) {
        const csvOutput = event.target.result;
        const jsonData = convertCSVToJson(csvOutput);

        console.log(jsonData)
        var newData = []
        for (let i = 0; i < jsonData.length; i++) {
          const jsonDatai = jsonData[i]
          newData.push({
            "title": { rendered: jsonDatai["Login Name"], },
            "status": "publish",
            "meta": {
              "roll_no": jsonDatai["Roll"],
              "name": jsonDatai["Name"],
              "phone": jsonDatai["Contact"],
              "address": jsonDatai["Address"],
              "email": jsonDatai["Email"],
              "admission_date": jsonDatai["AdmissionDate"],
              "course_amount": jsonDatai["CourseAmount"],
              "paid_amount": jsonDatai["Paid"],
              "remarks": jsonDatai["Remarks"],
            }
          })
        }
        setImportData(newData)
      };
      fileReader.readAsText(file);
    };
  }

  const convertCSVToJson = (csvData) => {
    const lines = csvData.split("\n");
    console.log(lines)
    const headers = lines[0].replace("\r", "").split(",");
    const result = [];
    // console.log(headers, lines[0])
    for (let i = 1; i < lines.length; i++) {
      var obj = {};
      const currentLine = lines[i].replace("\r", "").split(",");
      // console.log(currentLine)
      for (let j = 0; j < headers.length; j++) {
        // obj[headers[j].trim()] = currentLine[j].trim();
        console.log(headers[j])
        var key = headers[j]
        obj = {
          ...obj,
          [key]: currentLine[j]
        }
      }
      // console.log(obj)

      result.push(obj);
    }
    // setImportData(result)
    return result;
  };

  const columns2 = [
    // {
    //   id: 1,
    //   name: "id",
    //   selector: (row) => row.meta.user_id,
    //   sortable: true,
    //   reorder: true,
    // },
    {
      id: 31,
      name: "Title",
      selector: (row) => row.title.rendered,
      sortable: true,
      reorder: true
    },
    {
      id: 312,
      name: "Phone",
      selector: (row) => row.meta.user_phone_number,
      sortable: true,
      reorder: true
    },
    {
      id: 313,
      name: "Email",
      selector: (row) => row.meta.user_email,
      sortable: true,
      reorder: true
    },
    {
      id: 314,
      name: "Password",
      selector: (row) => row.meta.user_password,
      sortable: true,
      reorder: true
    },
    {
      id: 32,
      name: "role",
      selector: (row) => row.meta.user_role,
      sortable: true,
      reorder: true
    },
  ];



  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Student</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Student
        </div>
      </div>
      <a href={slugs.new_students}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}>
          Add New Student
        </div>
      </a>

      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setCustomersList(Projects1)
              }}
            >
              All ({Projects1.length}) |
            </div>
          </div>
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setDeleteUsersModal(Projects1)
              }}
            >
              Delete All
            </div>
          </div>
          <div style={{ display: "inline-block", margin: "0px 5px" }}
            onClick={() => {
              setImportData([])
              setToStudentModal(true)
            }}
          >
            Add Multiple |
          </div>
        </div>
        <div className="col-md-6 row">
          <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.title.rendered.toLowerCase().includes(event.target.value.toLowerCase())))
            }}
          />
          <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
            placeholder="Phone"
            onChange={(event) => {
              // setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.meta.phone.includes(event.target.value)))
            }}
          />
          <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
            placeholder="Course"
            onChange={(event) => {
              setCustomersList(Projects1.filter(a => a.meta.course_details.toLowerCase().includes(event.target.value.toLowerCase())))
            }}
          />
        </div>
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          pagination
          selectableRows
        />
      </div>
      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the student?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_students, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetAllProjects()
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all Students
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      }

      {toStudentModel &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-2 col-1"></div>
            <div className="col-md-8 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setToStudentModal(false)
                    setImportData([])
                  }}
                >X</div>
                <div style={{ display: "none" }} >
                  <input ref={fileRefSingle}
                    type={"file"}
                    id={"csvFileInput"}
                    accept={".csv"}
                    onChange={handleOnChange}
                  />
                </div>
                <div style={{ display: "inline", cursor: "pointer" }}>
                  <div style={{ display: "inline-block" }}>

                    <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
                      onClick={() => {
                        fileRefSingle.current.click()
                      }}
                    >Import CSV</div>
                  </div>
                  <div style={{ display: "inline-block" }}>
                    <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
                      onClick={() => {
                        setBatchSelectListModal(true)
                      }}
                    >Select Batch</div>
                  </div>
                </div>
                {Object.values(CourseDetails).map((item, index) => (
                  <span key={index}>{item.course_name} , </span>
                ))}
                {/* {JSON.stringify(ImportData)} */}
                {/* {JSON.stringify(CourseDetails)} */}
                <div style={{ maxHeight: "50vh", overflow: "scroll", backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <table style={{ maxHeight: "50vh" }}>
                    <thead>
                      <tr>
                        <td>SN</td>
                        <td>Name</td>
                        <td>Email</td>
                        <td>Phone Number</td>
                        <td>Address</td>
                        {/* <td>Role</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(ImportData).map((item, index) => (
                        <tr key={index}>
                          <TableRow row={item} index={index}
                            ImportData={ImportData} setImportData={setImportData} />
                        </tr>
                      ))}
                      {/* <TableRow row={item} index={index} /> */}

                      <tr>
                        <td colSpan={6} className="center" style={{ cursor: "pointer" }}
                          onClick={() => {
                            setImportData(
                              {
                                ...ImportData,
                                [Object.values(ImportData).length]: {
                                  "title": { rendered: "", },
                                  "meta": {
                                    "roll_no": "",
                                    "name": "",
                                    "email": "",
                                    "phone": "",
                                    "address": "",
                                    "admission_date": "",
                                  }
                                }
                              }
                            )
                          }}
                        >
                          Add New
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="row center">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setToStudentModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        const Projects = Object.values(ImportData)
                        for (let i = 0; i < Projects.length; i++) {
                          var courseDetailArray = Object.values(CourseDetails)
                          for (let j = 0; j < courseDetailArray.length; j++) {
                            courseDetailArray = {
                              ...CourseDetails,
                              [j]: {
                                ...courseDetailArray[j],
                                "course_joined_price": Projects[i].meta.course_amount,
                                "course_joined_date": Projects[i].meta.admission_date
                              }
                            }
                          }
                          var Payment = "Advanced Payment"
                          if (Projects[i].meta.course_amount == Projects[i].meta.paid_amount) {
                            Payment = "Full Payment"
                          }

                          const item = {
                            title: Projects[i].title.rendered,
                            "status": "publish",
                            meta: {
                              ...Projects[i].meta,
                              "course_details": JSON.stringify(courseDetailArray),
                              "is_active": Payment
                            }
                          }
                          setTimeout(() => {
                            setReload(true)


                            AdsPOSTApi(item, slugs.db_slug_students)
                              .then((res) => {
                                var studentDetails = res.data

                                var newValue = {
                                  "name": "",
                                  "qty": 0,
                                  "rate": 0,
                                  "total": 0
                                }
                                var courseList = JSON.parse(studentDetails.meta.course_details)
                                var courseListArray = Object.values(courseList)
                                var ItemList = {}
                                for (let k = 0; k < courseListArray.length; k++) {
                                  ItemList = {
                                    ...ItemList,
                                    [k]: {
                                      "name": courseListArray[k].course_name,
                                      "qty": 1,
                                      "rate": courseListArray[k].course_joined_price,
                                      "total": courseListArray[k].course_joined_price
                                    }
                                  }
                                }

                                // AdsGETApiAuth({ per_page: 1 }, slugs.db_slug_payments_received)
                                //   .then(res2 => {
                                // var receipt_number = Number(res2.headers["x-wp-total"]) + 1
                                console.log(Projects)
                                const data = {
                                  "title": `${studentDetails.meta.name} Payment ${studentDetails.date}`,
                                  "status": "publish",
                                  "meta": {
                                    "receipt_number": ``,
                                    "payment_type": `Student`,
                                    "student_id": `${studentDetails.id}`,
                                    "student_name": `${studentDetails.meta.name}`,
                                    "student_slug": `${studentDetails.slug}`,
                                    "payment_date": `${Projects[i].meta.admission_date}`,
                                    "amount": `${Projects[i].meta.paid_amount}`,
                                    "payment_mode": `Cash`,
                                    "items": JSON.stringify(ItemList),
                                    "reference_number": ``,
                                    "received_by": `NEA`,
                                    "remarks1": `${Projects[i].meta.remarks}`,
                                    "remarks2": ``,
                                    "remarks3": ``,
                                    "screenshot": ``,
                                    "received_from": ``
                                  }
                                }
                                AdsPOSTApi(data, slugs.db_slug_payments_received)
                                  .then(res => {
                                    setReload(false)
                                  })
                                // })
                              }).catch(err => {
                                console.log(err)
                              })
                          }, 1000)
                        }
                      }
                      }
                    >
                      Add All Student
                    </div>
                  </div>
                </div>
              </div>
              {batchSelectListModal &&
                <section className="modal" >
                  <div className="row" style={{ overflow: "hidden", marginTop: "30px" }}>
                    <div className="col-md-3 col-1"></div>
                    <div className="col-md-6 col-10  shadow bg-white">
                      <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                        <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                          onClick={() => {
                            setBatchSelectListModal(false)
                            setImportData([])

                          }}
                        >X</div>
                        Batches List
                        <div style={{ height: "50vh", overflowY: "scroll", }}>
                          <table style={{}}>
                            <thead>
                              <tr>
                                <td>SN</td>
                                <td>Course</td>
                                <td>Batch</td>
                                <td>Session</td>
                              </tr>
                              {batchList.map((item, index) => (
                                <tr key={index}
                                  onClick={() => {

                                    var newkey = Object.keys(CourseDetails).length == 0 ? "0" : Object.keys(CourseDetails).length

                                    setCourseDetails({
                                      ...CourseDetails,
                                      ["0"]: {
                                        // ...Object.values(CourseDetails)[newkey],
                                        // "course_joined_date": event.target.value
                                        course_name: item.meta.course_name,
                                        batch_name: item.meta.batch_name,
                                        session: item.meta.session_name,
                                        "course_joined_price": "",
                                        "course_joined_date": ""
                                      }
                                    })
                                    setBatchSelectListModal(false)
                                  }}

                                >
                                  <td>{index + 1}</td>
                                  <td>{item.meta.course_name}</td>
                                  <td>{item.meta.batch_name}</td>
                                  <td>{item.meta.session_name}</td>

                                </tr>
                              ))}
                            </thead>
                          </table>
                        </div>
                        <div style={{ padding: "10px" }}>
                          <div className="row">
                            <div className="col-1" />
                            <div className="col-5 center " >
                              <div className="sign-in-button-4" style={{ width: "80%" }}
                                onClick={() => {
                                  setBatchCacheList(batchSelectList)
                                  // setBatchExamIDCache(BatchExamID)
                                  setBatchSelectListModal(false)
                                }}
                              >
                                Cancel
                              </div>
                            </div>
                            <div className="col-5 center">
                              <div className="sign-in-button-4" style={{ width: "80%" }}
                                onClick={() => {
                                  setBatchSelectList(batchCacheList)
                                  // setBatchExamID(BatchExamIDCache)
                                  setBatchSelectListModal(false)
                                }}
                              >
                                Done
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              }

            </div>
          </div>
          {Reload &&
            <div className="modal" style={{ padding: "50vw" }}>
              <div className="dot-pulse"></div>
            </div>
          }
        </section>
      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}



const TableRow = ({ row, index, ImportData, setImportData }) => {
  const [name, setName] = React.useState(row.meta.name)
  const [email, setEmail] = React.useState(row.meta.email)
  // const [PassWord, setPassword] = React.useState(row.meta.user_password)
  const [PhoneNumber, setPhoneNumber] = React.useState(row.meta.phone)
  const [address, setAddress] = React.useState(row.meta.address)
  const [date, setDate] = React.useState(row.meta.admission_date)
  // const [Role, setRole] = React.useState(row.meta.user_role)
  return (
    <>
      <td>{index + 1}</td>
      <td>
        <input className="input-common-2"
          value={name} placeholder="User Name"
          onChange={(event) => {
            setName(event.target.value)
            console.log(JSON.stringify(ImportData[index]))

            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: { rendered: event.target.value },
                meta: { ...ImportData[index].meta, name: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      <td>
        <input className="input-common-2"
          value={email} placeholder="Email"
          onChange={(event) => {
            setEmail(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, email: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>

      <td>
        <input className="input-common-2"
          value={PhoneNumber} placeholder="Phone Number"
          onChange={(event) => {
            setPhoneNumber(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, phone: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      <td>
        <input className="input-common-2"
          value={address} placeholder="Address"
          onChange={(event) => {
            setAddress(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, address: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      {/* <td>
        <input className="input-common-2"
          value={date} placeholder="Admission Date"
          onChange={(event) => {
            setDate(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, date: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td> */}
    </>
  )
}

const CustomButton = ({ setData, Data, DataValue, ImportData, setImportData, index }) => {
  return (
    <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
      onClick={() => {
        setData(DataValue)
        const ImportData2 = {
          ...ImportData,
          [index]: {
            title: ImportData[index].title,
            meta: { ...ImportData[index].meta, user_role: DataValue }
          }
        }
        setImportData(ImportData2)
      }}
    >
      <div className={Data == DataValue ? "active-option-2" : "passive-option-2"}>
        {DataValue}
      </div>
    </button>
  )
}